import {
  Button,
  Drawer,
  Image,
  Input,
  List,
  Alert,
  Collapse,
  Typography,
} from "antd";
import Logo from "assets/images/logo.svg";
import { EntryClassifier } from "utilities/enums";
import { Scrollbar } from "react-scrollbars-custom";
import { downloadEvent } from "utilities/generalUtility";

const { TextArea } = Input;
const { Title } = Typography;
const { Panel } = Collapse;
export default function AiDrawer({
  openDrawer,
  closeChatDrawer,
  resolveResponseRef,
  sendRevised,
  relationModalDecision,
  btnLoading,
  editJournalText,
  isEntryModalOpen,
}) {
  return (
    <Drawer
      title={<Image preview={false} src={Logo} />}
      placement="bottom"
      closable={false}
      onClose={closeChatDrawer}
      open={openDrawer}
      className="show-chat-drawer"
      extra={
        <Button
          type="text"
          className="drawer-close"
          icon={<i className="icon-x-circle"></i>}
          onClick={closeChatDrawer}
        ></Button>
      }
    >
      <div className="list-wrapper list-view">
        <div className="view-wrapper">
          <div className="items">
            <div className="original-chat">
              <Scrollbar>
                <TextArea
                  readOnly
                  value={resolveResponseRef.current?.original_message}
                  className="note-book"
                  autoSize={true}
                />
              </Scrollbar>
            </div>
            <div className="btn-wrap">
              <Button
                danger
                type="primary"
                onClick={() => {
                  downloadEvent("SendOriginal");
                  sendRevised.current = false;
                  relationModalDecision();
                }}
                loading={
                  btnLoading && !sendRevised.current && !isEntryModalOpen
                }
              >
                Send Original Journal Entry
              </Button>
            </div>
          </div>
          {resolveResponseRef.current?.input_class !==
            EntryClassifier.GIBBERISH_TEXT &&
            resolveResponseRef?.current?.is_revised &&
            resolveResponseRef?.current.original_message !==
              resolveResponseRef?.current?.revised_message && (
              <div className="items">
                <div className="resolve-chat">
                  <Scrollbar>
                    <TextArea
                      readOnly
                      value={resolveResponseRef.current?.revised_message}
                      className="note-book"
                      autoSize={true}
                    />
                  </Scrollbar>
                </div>
                <div className="btn-wrap">
                  <Button
                    className="resolve-ai-btn"
                    type="primary"
                    onClick={() => {
                      downloadEvent("SendResolved");
                      sendRevised.current = true;
                      relationModalDecision();
                    }}
                    loading={
                      btnLoading && sendRevised.current && !isEntryModalOpen
                    }
                  >
                    Send RESOLVEit
                  </Button>
                  <Button
                    className="edit-resolveit"
                    ghost
                    onClick={() => {
                      downloadEvent("EditResolved");

                      editJournalText(
                        resolveResponseRef.current?.revised_message
                      );
                    }}
                  >
                    Edit RESOLVEit
                  </Button>
                </div>
              </div>
            )}
        </div>
        {resolveResponseRef.current?.input_class ===
          EntryClassifier.GIBBERISH_TEXT ||
        (resolveResponseRef?.current?.input_class ===
          EntryClassifier.NORMAL_TEXT &&
          !resolveResponseRef?.current?.is_revised) ||
        (resolveResponseRef?.current?.input_class ===
          EntryClassifier.NORMAL_TEXT &&
          resolveResponseRef?.current.original_message ===
            resolveResponseRef?.current?.revised_message) ? (
          <Alert
            icon={<i className="icon-warning"></i>}
            className="ai-error-message"
            message={
              resolveResponseRef.current?.input_class ===
              EntryClassifier.GIBBERISH_TEXT
                ? "It seems you entered some gibberish text."
                : "The original message is neutral, hence no revision is required."
            }
            type="error"
            showIcon
          />
        ) : (
          resolveResponseRef.current?.overall_impact && (
            <div className="list-impact">
              <Title level={5}>Reason for change:</Title>
              <p>{resolveResponseRef.current?.overall_impact}</p>
            </div>
          )
        )}
        {resolveResponseRef.current?.connotations &&
          resolveResponseRef.current?.connotations.length > 0 && (
            <Collapse
              className="connation-collapse"
              expandIconPosition={"end"}
              expandIcon={({ isActive }) =>
                !isActive ? (
                  <i
                    className="icon-chevron-down"
                    style={{ fontSize: "8px" }}
                  />
                ) : (
                  <i className="icon-chevron-up" style={{ fontSize: "8px" }} />
                )
              }
            >
              <Panel header="Connotations Identified in your message" key="1">
                {resolveResponseRef.current?.connotations.map((element) => {
                  return (
                    <div className="cc-content-wrap">
                      <h2>{element?.connotation}</h2>
                      <div className="cc-info">
                        <h3>Reason Its marked as connotation</h3>
                        <p>{element?.reason}</p>
                        <h3>Impact it could make</h3>
                        <p>{element?.impact}</p>
                      </div>
                    </div>
                  );
                })}
              </Panel>
            </Collapse>
          )}
      </div>
    </Drawer>
  );
}
